import React, { useRef, useState } from "react";
import styled from "styled-components";
import { cloneDeep } from 'lodash';

import FetchModule from "../../../Model/Share/Network/FetchModule";
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { ReactComponent as EditSvg } from '../../../image/Edit.svg';
import { ReactComponent as CopySvg } from '../../../image/Copy.svg';
import { ReactComponent as ExitButtonSvg } from '../../../image/ExitButtonImage.svg';
import SettingInput from "./SettingInput";
import IndexSettingInput from "./IndexSettingInput";
import MoreExplanationView from "./MoreExplanationView";
import { UNSUBSCRIBE_TEXT } from "./ContentInput";

export default function ExpiredSettingMessageBox(props) {
  const {
    onRequireCard,
    expired,
    setExpired,
    isUseDuplicateLimit,
    onClickDuplicateLimit,
    onClickEdit
  } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [willSavedData, setWillSavedData] = useState({
    data: undefined,
    index: undefined
  });

  const BeExpiredMembershipTimerRef = useRef(null);
  const BeExpiredLockerTimerRef = useRef(null);
  const ExpiredMembershipTimerRef = useRef(null);
  const HadBeenExpiredMembershipTimerRef = useRef(null);
  const HadBeenExpiredLockerTimerRef = useRef(null);
  const StartMembershipHoldingTimerRef = useRef(null);

  // 회원권 만료 예정 날짜 변경시 //
  function onChangeBeExpiredMembershipDay(value, index) {
    if (onRequireCard && !onRequireCard()) return;

    if (value < 100) {
      let newData = cloneDeep(expired);

      newData.beExpiredMembership[index].applyDay = value;

      setExpired(newData);
      setWillSavedData({data: newData.beExpiredMembership[index], index: index});

      if (BeExpiredMembershipTimerRef.current !== null) clearTimeout(BeExpiredMembershipTimerRef.current);

      BeExpiredMembershipTimerRef.current = setTimeout(async () => {
        saveMessageSetting(newData.beExpiredMembership[index], index);
      }, 3000);
    }
  }

  // 회원권 만료 예정 시간 변경시 //
  function onChangeBeExpiredMembershipTime(value, index) {
    if (onRequireCard && !onRequireCard()) return;

    if (value !== '') {
      let newData = cloneDeep(expired);

      newData.beExpiredMembership[index].applyTime = value;

      setExpired(newData);
      setWillSavedData({data: newData.beExpiredMembership[index], index: index});

      if (BeExpiredMembershipTimerRef.current !== null) clearTimeout(BeExpiredMembershipTimerRef.current);

      BeExpiredMembershipTimerRef.current = setTimeout(async () => {
        saveMessageSetting(newData.beExpiredMembership[index], index);
      }, 3000);
    }
  }

  // 락커 만료 예정 날짜 변경시 //
  function onChangeBeExpiredLockerDay(value, index) {
    if (onRequireCard && !onRequireCard()) return;

    if (value < 100) {
      let newData = cloneDeep(expired);

      newData.beExpiredLocker[index].applyDay = value;

      setExpired(newData);
      setWillSavedData({data: newData.beExpiredLocker[index], index: index});

      if (BeExpiredLockerTimerRef.current !== null) clearTimeout(BeExpiredLockerTimerRef.current);

      BeExpiredLockerTimerRef.current = setTimeout(async () => {
        saveMessageSetting(newData.beExpiredLocker[index], index);
      }, 3000);
    }
  }

  // 락커 만료 예정 시간 변경시 //
  function onChangeBeExpiredLockerTime(value, index) {
    if (onRequireCard && !onRequireCard()) return;

    if (value !== '') {
      let newData = cloneDeep(expired);

      newData.beExpiredLocker[index].applyTime = value;

      setExpired(newData);
      setWillSavedData({data: newData.beExpiredLocker[index], index: index});

      if (BeExpiredLockerTimerRef.current !== null) clearTimeout(BeExpiredLockerTimerRef.current);

      BeExpiredLockerTimerRef.current = setTimeout(async () => {
        saveMessageSetting(newData.beExpiredLocker[index], index);
      }, 3000);
    }
  }

  // 회원권 만료 시간 변경시 //
  function onChangeExpiredMembershipTime(value) {
    if (onRequireCard && !onRequireCard()) return;

    if (value !== '') {
      let newData = cloneDeep(expired);

      newData.expiredMembership.applyTime = value;

      setExpired(newData);

      if (ExpiredMembershipTimerRef.current !== null) clearTimeout(ExpiredMembershipTimerRef.current);

      ExpiredMembershipTimerRef.current = setTimeout(async () => {
        saveMessageSetting(newData.expiredMembership, -1);
      }, 3000);
    }
  }

  // 회원권 만료 후 날짜 변경시 //
  function onChangeHadBeenExpiredMembershipDay(value, index) {
    if (onRequireCard && !onRequireCard()) return;

    if (value < 100) {
      let newData = cloneDeep(expired);

      newData.hadBeenExpiredMembership[index].applyDay = value;

      setExpired(newData);
      setWillSavedData({data: newData.hadBeenExpiredMembership[index], index: index});

      if (HadBeenExpiredMembershipTimerRef.current !== null) clearTimeout(HadBeenExpiredMembershipTimerRef.current);

      HadBeenExpiredMembershipTimerRef.current = setTimeout(async () => {
        saveMessageSetting(newData.hadBeenExpiredMembership[index], index);
      }, 3000);
    }
  }

  // 회원권 만료 후 시간 변경시 //
  function onChangeHadBeenExpiredMembershipTime(value, index) {
    if (onRequireCard && !onRequireCard()) return;

    if (value !== '') {
      let newData = cloneDeep(expired);

      newData.hadBeenExpiredMembership[index].applyTime = value;

      setExpired(newData);
      setWillSavedData({data: newData.hadBeenExpiredMembership[index], index: index});

      if (HadBeenExpiredMembershipTimerRef.current !== null) clearTimeout(HadBeenExpiredMembershipTimerRef.current);

      HadBeenExpiredMembershipTimerRef.current = setTimeout(async () => {
        saveMessageSetting(newData.hadBeenExpiredMembership[index], index);
      }, 3000);
    }
  }

  // 락커 만료 후 날짜 변경시 //
  function onChangeHadBeenExpiredLockerDay(value, index) {
    if (onRequireCard && !onRequireCard()) return;

    if (value < 100) {
      let newData = cloneDeep(expired);

      newData.hadBeenExpiredLocker[index].applyDay = value;

      setExpired(newData);
      setWillSavedData({data: newData.hadBeenExpiredLocker[index], index: index});

      if (HadBeenExpiredLockerTimerRef.current !== null) clearTimeout(HadBeenExpiredLockerTimerRef.current);

      HadBeenExpiredLockerTimerRef.current = setTimeout(async () => {
        saveMessageSetting(newData.hadBeenExpiredLocker[index], index);
      }, 3000);
    }
  }

  // 락커 만료 후 시간 변경시 //
  function onChangeHadBeenExpiredLockerTime(value, index) {
    if (onRequireCard && !onRequireCard()) return;

    if (value !== '') {
      let newData = cloneDeep(expired);

      newData.hadBeenExpiredLocker[index].applyTime = value;

      setExpired(newData);
      setWillSavedData({data: newData.hadBeenExpiredLocker[index], index: index});

      if (HadBeenExpiredLockerTimerRef.current !== null) clearTimeout(HadBeenExpiredLockerTimerRef.current);

      HadBeenExpiredLockerTimerRef.current = setTimeout(async () => {
        saveMessageSetting(newData.hadBeenExpiredLocker[index], index);
      }, 3000);
    }
  }

  // 회원권 활성화 날짜 변경시 //
  function onChangeStartMembershipHoldingDay(value) {
    if (onRequireCard && !onRequireCard()) return;

    if (value < 100) {
      let newData = cloneDeep(expired);

      newData.startMembershipHolding.applyDay = value;

      setExpired(newData);

      if (StartMembershipHoldingTimerRef.current !== null) clearTimeout(StartMembershipHoldingTimerRef.current);

      StartMembershipHoldingTimerRef.current = setTimeout(async () => {
        saveMessageSetting(newData.startMembershipHolding, -1);
      }, 3000);
    }
  }

  // 회원권 활성화 시간 변경시 //
  function onChangeStartMembershipHoldingTime(value) {
    if (onRequireCard && !onRequireCard()) return;

    if (value !== '') {
      let newData = cloneDeep(expired);

      newData.startMembershipHolding.applyTime = value;

      setExpired(newData);

      if (StartMembershipHoldingTimerRef.current !== null) clearTimeout(StartMembershipHoldingTimerRef.current);

      StartMembershipHoldingTimerRef.current = setTimeout(async () => {
        saveMessageSetting(newData.startMembershipHolding, -1);
      }, 3000);
    }
  }

  // applyTime "HH:MM" 문자열 → { applyTime: 시, applyMinute: 분 } 정수 (백엔드 전송용) //
  function splitApplyTime(value) {
    if (typeof value === 'string' && value.includes(':')) {
      const [hour, minute] = value.split(':');

      return { applyTime: parseInt(hour, 10) || 0, applyMinute: parseInt(minute, 10) || 0 };
    }

    return { applyTime: parseInt(value, 10) || 0, applyMinute: 0 };
  }

  // 백엔드 응답(시/분 정수) → applyTime "HH:MM" 문자열로 정규화 (화면 표시용) //
  function normalizeSetting(data) {
    let hour = String(data.applyTime ?? 0).padStart(2, '0');
    let minute = String(data.applyMinute ?? 0).padStart(2, '0');

    return { ...data, applyTime: `${hour}:${minute}` };
  }

  // 변수 → 칩 렌더링 //
  function renderText(value) {
    const variableMap = {
      '{store_name}': t('messageSend.variable.storeName'),
      '{user_name}': t('messageSend.variable.userName'),
      '{membership_name}': t('messageSend.variable.membershipName'),
      '{exercise_period}': t('messageSend.variable.exercisePeriod'),
      '{locker_name}': t('messageSend.variable.lockerName'),
      '{coach_name}': t('messageSend.variable.coachName'),
      '{class_name}': t('messageSend.variable.className'),
      '{reserve_time}': t('messageSend.variable.reserveTime'),
      '{class_time}': t('messageSend.variable.classTime'),
      '{holding_start_date}': t('messageSend.variable.holdingStartDate'),
      '{holding_end_date}': t('messageSend.variable.holdingEndDate'),
    };
    const lines = value.split('\n').map((line, lineIdx) => (
      <MessageLine key={lineIdx}>
        {line.split(/(\{[^}]+\})/g).map((part, i) => {
          const label = variableMap[part];
          if (label) return <VariableChip key={i}>{label.replace(/^\{|\}$/g, '')}</VariableChip>;
          return part ? <span key={i}>{part}</span> : null;
        })}
      </MessageLine>
    ));

    // 무료수신거부 문구는 모든 문자 하단에 자동 포함 //
    lines.push(<UnsubscribeText key={'Unsubscribe'}>{UNSUBSCRIBE_TEXT}</UnsubscribeText>);

    return lines;
  }

  // 무료수신거부 문구 포함 메시지 타입/글자 수 정보 (실제 발송 문자 기준) //
  function decideMessageInfo(text) {
    const fullText = text + '\n\n' + UNSUBSCRIBE_TEXT;

    return `${getMessageType(fullText)} ${fullText.length}${t('messageSend.editModal.smsCharCountSuffix')}`;
  }

  // SMS/LMS 판별 (90바이트 초과 시 LMS) //
  function getMessageType(text) {
    let bytes = 0;
    for (let i = 0; i < text.length; i++) {
      bytes += text.charCodeAt(i) > 127 ? 2 : 1;
    }
    return bytes > 90 ? 'LMS' : 'SMS';
  }

  // 토글 클릭시 //
  function onClickToggle(division, index) {
    if (onRequireCard && !onRequireCard()) return;

    let newData = cloneDeep(expired);

    // 회원권 만료 예정 //
    if (division === 'BeExpiredMembership') {
      newData.beExpiredMembership[index].isUseSetting = !newData.beExpiredMembership[index].isUseSetting;

      saveMessageSetting(newData.beExpiredMembership[index], index);
    }
    // 락커 만료 예정 //
    else if (division === 'BeExpiredLocker') {
      newData.beExpiredLocker[index].isUseSetting = !newData.beExpiredLocker[index].isUseSetting;

      saveMessageSetting(newData.beExpiredLocker[index], index);
    }
    // 회원권 만료시//
    else if (division === 'ExpiredMembership') {
      newData.expiredMembership.isUseSetting = !newData.expiredMembership.isUseSetting;

      saveMessageSetting(newData.expiredMembership, -1);
    }
    // 회원권 만료 후 //
    else if (division === 'HadBeenExpiredMembership') {
      newData.hadBeenExpiredMembership[index].isUseSetting = !newData.hadBeenExpiredMembership[index].isUseSetting;

      saveMessageSetting(newData.hadBeenExpiredMembership[index], index);
    }
    // 락커 만료 후 //
    else if (division === 'HadBeenExpiredLocker') {
      newData.hadBeenExpiredLocker[index].isUseSetting = !newData.hadBeenExpiredLocker[index].isUseSetting;

      saveMessageSetting(newData.hadBeenExpiredLocker[index], index);
    }
    // 홀딩 적용시 //
    else if (division === 'ApplyMembershipHolding') {
      newData.applyMembershipHolding.isUseSetting = !newData.applyMembershipHolding.isUseSetting;

      saveMessageSetting(newData.applyMembershipHolding, -1);
    }
    // 홀딩 시작시 //
    else if (division === 'StartMembershipHolding') {
      newData.startMembershipHolding.isUseSetting = !newData.startMembershipHolding.isUseSetting;

      saveMessageSetting(newData.startMembershipHolding, -1);
    }

  }

  // Input 포커싱 잃는경우 바로 저장 //
  function onBlurInput() {
    if (willSavedData.data !== undefined) {
      saveMessageSetting(willSavedData.data, willSavedData.index);

      if (willSavedData.data.division === 'BeExpiredMembership') clearTimeout(BeExpiredMembershipTimerRef.current);
      else if (willSavedData.data.division === 'BeExpiredLocker') clearTimeout(BeExpiredLockerTimerRef.current);
      else if (willSavedData.data.division === 'HadBeenExpiredMembership') clearTimeout(HadBeenExpiredMembershipTimerRef.current);
      else if (willSavedData.data.division === 'HadBeenExpiredLocker') clearTimeout(HadBeenExpiredLockerTimerRef.current);

      setWillSavedData({data: undefined, index: undefined});
    }
  }

  // 데이터 추가 클릭시 //
  function onClickAddOrDeleteButton(data, isAdd) {
    // 데이터 추가의 경우 //
    if (isAdd) {
      let requestData = {
        id: 0,
        storeId: 0,
        division: data.division,
        text: data.text,
        title: data.title,
        applyDay: data.applyDay,
        ...splitApplyTime(data.applyTime),
        isUseSetting: data.isUseSetting
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('message_setting/save', 'POST', requestData);

          if (responseData.status === 200) {
            let newData = cloneDeep(expired);
            let savedData = normalizeSetting(responseData.data);

            if (data.division === 'BeExpiredMembership') newData.beExpiredMembership.push(savedData);
            else if (data.division === 'BeExpiredLocker') newData.beExpiredLocker.push(savedData);
            else if (data.division === 'HadBeenExpiredMembership') newData.hadBeenExpiredMembership.push(savedData);
            else if (data.division === 'HadBeenExpiredLocker') newData.hadBeenExpiredLocker.push(savedData);

            setExpired(newData);
          }
        }
      )();
    }
    // 데이터 삭제의 경우 //
    else {
      let requestData = {
        id: data.id
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('message_setting/delete', 'POST', requestData);
          if (responseData.status === 200) {
            let newData = cloneDeep(expired);

            if (data.division === 'BeExpiredMembership') {
              let updateList = newData.beExpiredMembership.filter(obj => obj.id !== data.id);

              newData.beExpiredMembership = updateList;
            }
            else if (data.division === 'BeExpiredLocker') {
              let updateList = newData.beExpiredLocker.filter(obj => obj.id !== data.id);

              newData.beExpiredLocker = updateList;
            }
            else if (data.division === 'HadBeenExpiredMembership') {
              let updateList = newData.hadBeenExpiredMembership.filter(obj => obj.id !== data.id);

              newData.hadBeenExpiredMembership = updateList;
            }
            else if (data.division === 'HadBeenExpiredLocker') {
              let updateList = newData.hadBeenExpiredLocker.filter(obj => obj.id !== data.id);

              newData.hadBeenExpiredLocker = updateList;
            }

            setExpired(newData);
          }
        }
      )();
    }
  }

  // 데이터 저장 //
  function saveMessageSetting(data, index) {
    let requestData = {
      id: data.id,
      storeId: data.storeId,
      division: data.division,
      text: data.text,
      title: data.title,
      applyDay: data.applyDay,
      ...splitApplyTime(data.applyTime),
      isUseSetting: data.isUseSetting
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('message_setting/save', 'POST', requestData);

        if (responseData.status === 200) {
          let newData = cloneDeep(expired);
          let savedData = normalizeSetting(responseData.data);

          if (data.division === 'BeExpiredMembership') newData.beExpiredMembership[index] = savedData;
          else if (data.division === 'BeExpiredLocker') newData.beExpiredLocker[index] = savedData;
          else if (data.division === 'ExpiredMembership') newData.expiredMembership = savedData;
          else if (data.division === 'HadBeenExpiredMembership') newData.hadBeenExpiredMembership[index] = savedData;
          else if (data.division === 'HadBeenExpiredLocker') newData.hadBeenExpiredLocker[index] = savedData;
          else if (data.division === 'ApplyMembershipHolding') newData.applyMembershipHolding = savedData;
          else if (data.division === 'StartMembershipHolding') newData.startMembershipHolding = savedData;

          setExpired(newData);
        }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      <HeaderWrapper>
        <DivisionBox>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.primary}>{t('messageSend.autoMessage.expiredHold')}</Text>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText}>{t('messageSend.editModal.descExpiredSetting')}</Text>
        </DivisionBox>
        <DuplicateLimitWrapper>
          <DuplicateLimitTitleWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.text}>{t('messageSend.autoMessage.duplicateNoticeLimit')}</Text>
            <MoreExplanationView text={t('messageSend.autoMessage.duplicateNoticeLimitTooltip')} />
          </DuplicateLimitTitleWrapper>
          <DuplicateLimitControlWrapper>
            <SlideOutBox
              isClicked={isUseDuplicateLimit}
              onClick={onClickDuplicateLimit}>
              <SlideInBox isClicked={isUseDuplicateLimit} />
            </SlideOutBox>
            <StateTextWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isUseDuplicateLimit ? theme.text : theme.subText}>{isUseDuplicateLimit ? t('messageSend.autoMessage.active') : t('messageSend.autoMessage.inactive')}</Text>
            </StateTextWrapper>
          </DuplicateLimitControlWrapper>
        </DuplicateLimitWrapper>
      </HeaderWrapper>
      
      <SettingBox>
        {
          expired.beExpiredMembership.map((data, index) =>
            <SettingColumnBoxWrapper key={'BeExpiredMembership-' + index}>
              <SettingColumnBox>
                <SlideComponentWrapper>
                  <SlideOutBox
                    isClicked={data.isUseSetting}
                    onClick={() => onClickToggle('BeExpiredMembership', index)}>
                    <SlideInBox isClicked={data.isUseSetting} />
                  </SlideOutBox>
                  <CheckBoxTextWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.text}>{t('messageSend.autoMessage.expiringSoon')}</Text>
                    <SettingCaptionTextWrapper>
                      <InputWrapper onClick={e => e.stopPropagation()}>
                        <IndexSettingInput
                          index={index}
                          value={data.applyDay}
                          setValue={onChangeBeExpiredMembershipDay}
                          onBlur={onBlurInput}
                          placeholder={0}/>
                      </InputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('messageSend.autoMessage.daysBefore')}</Text>
                      <InputWrapper onClick={e => e.stopPropagation()}>
                        <IndexSettingInput
                          index={index}
                          value={data.applyTime}
                          setValue={onChangeBeExpiredMembershipTime}
                          onBlur={onBlurInput}
                          placeholder='00:00'
                          isTimeType={true} />
                      </InputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('messageSend.autoMessage.atTime')}</Text>
                    </SettingCaptionTextWrapper>
                  </CheckBoxTextWrapper>
                </SlideComponentWrapper>
                <SettingTextWrapper>
                  <TextWrapper>
                    <MessageText>{renderText(data.text)}</MessageText>
                    <CharCountText>{decideMessageInfo(data.text)}</CharCountText>
                  </TextWrapper>
                </SettingTextWrapper>
                <ButtonWrapper>
                  <PlusButtonWrapper onClick={() => onClickAddOrDeleteButton(data, index === 0)}>
                    {index === 0 ? <CopyIcon /> : <ExitButtonIcon />}
                  </PlusButtonWrapper>
                  <ModifyButton onClick={() => onClickEdit(data)}>
                    <EditIcon />
                  </ModifyButton>
                </ButtonWrapper>
              </SettingColumnBox>
            </SettingColumnBoxWrapper>
          )
        }
        <DivisionLine />
        {
          expired.beExpiredLocker.map((data, index) =>
            <SettingColumnBoxWrapper key={'BeExpiredLocker-' + index}>
              <SettingColumnBox>
                <SlideComponentWrapper>
                  <SlideOutBox
                    isClicked={data.isUseSetting}
                    onClick={() => onClickToggle('BeExpiredLocker', index)}>
                    <SlideInBox isClicked={data.isUseSetting} />
                  </SlideOutBox>
                  <CheckBoxTextWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.text}>{t('messageSend.autoMessage.lockerExpiringSoon')}</Text>
                    <SettingCaptionTextWrapper>
                      <InputWrapper onClick={e => e.stopPropagation()}>
                        <IndexSettingInput
                          index={index}
                          value={data.applyDay}
                          setValue={onChangeBeExpiredLockerDay}
                          onBlur={onBlurInput}
                          placeholder={0} />
                      </InputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('messageSend.autoMessage.daysBefore')}</Text>
                      <InputWrapper onClick={e => e.stopPropagation()}>
                        <IndexSettingInput
                          index={index}
                          value={data.applyTime}
                          setValue={onChangeBeExpiredLockerTime}
                          onBlur={onBlurInput}
                          placeholder='00:00'
                          isTimeType={true} />
                      </InputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('messageSend.autoMessage.atTime')}</Text>
                    </SettingCaptionTextWrapper>
                  </CheckBoxTextWrapper>
                </SlideComponentWrapper>
                <SettingTextWrapper>
                  <TextWrapper>
                    <MessageText>{renderText(data.text)}</MessageText>
                    <CharCountText>{decideMessageInfo(data.text)}</CharCountText>
                  </TextWrapper>
                </SettingTextWrapper>
                <ButtonWrapper>
                  <PlusButtonWrapper onClick={() => onClickAddOrDeleteButton(data, index === 0)}>
                    {index === 0 ? <CopyIcon /> : <ExitButtonIcon />}
                  </PlusButtonWrapper>
                  <ModifyButton onClick={() => onClickEdit(data)}>
                    <EditIcon />
                  </ModifyButton>
                </ButtonWrapper>
              </SettingColumnBox>
            </SettingColumnBoxWrapper>
          )
        }
        <DivisionLine />
        <SettingColumnBox>
          <SlideComponentWrapper>
            <SlideOutBox
              isClicked={expired.expiredMembership.isUseSetting}
              onClick={() => onClickToggle('ExpiredMembership', -1)}>
              <SlideInBox isClicked={expired.expiredMembership.isUseSetting} />
            </SlideOutBox>
            <CheckBoxTextWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.text}>{t('messageSend.autoMessage.membershipExpiry')}</Text>
              <SettingCaptionTextWrapper>
                <InputWrapper onClick={e => e.stopPropagation()}>
                  <SettingInput
                    value={expired.expiredMembership.applyTime}
                    setValue={onChangeExpiredMembershipTime}
                    placeholder='00:00'
                    isTimeType={true}/>
                </InputWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('messageSend.autoMessage.atTime')}</Text>
              </SettingCaptionTextWrapper>
            </CheckBoxTextWrapper>
          </SlideComponentWrapper>
          <SettingTextWrapper>
            <TextWrapper>
              <MessageText>{renderText(expired.expiredMembership.text)}</MessageText>
              <CharCountText>{decideMessageInfo(expired.expiredMembership.text)}</CharCountText>
            </TextWrapper>
          </SettingTextWrapper>
          <ButtonWrapper>
            <ModifyButton onClick={() => onClickEdit(expired.expiredMembership)}>
              <EditIcon />
            </ModifyButton>
          </ButtonWrapper>
        </SettingColumnBox>

        <DivisionLine />

        {
          expired.hadBeenExpiredMembership.map((data, index) =>
            <SettingColumnBoxWrapper key={'HadBeenExpiredMembership-' + index}>
              <SettingColumnBox>
                <SlideComponentWrapper>
                  <SlideOutBox
                    isClicked={data.isUseSetting}
                    onClick={() => onClickToggle('HadBeenExpiredMembership', index)}>
                    <SlideInBox isClicked={data.isUseSetting} />
                  </SlideOutBox>
                  <CheckBoxTextWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.text}>{t('messageSend.autoMessage.membershipExpiredAfter')}</Text>
                    <SettingCaptionTextWrapper>
                      <InputWrapper onClick={e => e.stopPropagation()}>
                        <IndexSettingInput
                          index={index}
                          value={data.applyDay}
                          setValue={onChangeHadBeenExpiredMembershipDay}
                          onBlur={onBlurInput}
                          placeholder={0}/>
                      </InputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('messageSend.autoMessage.daysAfter')}</Text>
                      <InputWrapper onClick={e => e.stopPropagation()}>
                        <IndexSettingInput
                          index={index}
                          value={data.applyTime}
                          setValue={onChangeHadBeenExpiredMembershipTime}
                          onBlur={onBlurInput}
                          placeholder='00:00'
                          isTimeType={true}/>
                      </InputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('messageSend.autoMessage.atTime')}</Text>
                    </SettingCaptionTextWrapper>
                  </CheckBoxTextWrapper>
                </SlideComponentWrapper>
                <SettingTextWrapper>
                  <TextWrapper>
                    <MessageText>{renderText(data.text)}</MessageText>
                    <CharCountText>{decideMessageInfo(data.text)}</CharCountText>
                  </TextWrapper>
                </SettingTextWrapper>
                <ButtonWrapper>
                  <PlusButtonWrapper onClick={() => onClickAddOrDeleteButton(data, index === 0)}>
                    {index === 0 ? <CopyIcon /> : <ExitButtonIcon />}
                  </PlusButtonWrapper>
                  <ModifyButton onClick={() => onClickEdit(data)}>
                    <EditIcon />
                  </ModifyButton>
                </ButtonWrapper>
              </SettingColumnBox>
            </SettingColumnBoxWrapper>
          )
        }
        <DivisionLine />
        {
          expired.hadBeenExpiredLocker.map((data, index) =>
            <SettingColumnBoxWrapper key={'HadBeenExpiredLocker-' + index}>
              <SettingColumnBox>
                <SlideComponentWrapper>
                  <SlideOutBox
                    isClicked={data.isUseSetting}
                    onClick={() => onClickToggle('HadBeenExpiredLocker', index)}>
                    <SlideInBox isClicked={data.isUseSetting} />
                  </SlideOutBox>
                  <CheckBoxTextWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.text}>{t('messageSend.autoMessage.lockerExpiredAfter')}</Text>
                    <SettingCaptionTextWrapper>
                      <InputWrapper onClick={e => e.stopPropagation()}>
                        <IndexSettingInput
                          index={index}
                          value={data.applyDay}
                          setValue={onChangeHadBeenExpiredLockerDay}
                          onBlur={onBlurInput}
                          placeholder={0} />
                      </InputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('messageSend.autoMessage.daysAfter')}</Text>
                      <InputWrapper onClick={e => e.stopPropagation()}>
                        <IndexSettingInput
                          index={index}
                          value={data.applyTime}
                          setValue={onChangeHadBeenExpiredLockerTime}
                          onBlur={onBlurInput}
                          placeholder='00:00'
                          isTimeType={true} />
                      </InputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('messageSend.autoMessage.atTime')}</Text>
                    </SettingCaptionTextWrapper>
                  </CheckBoxTextWrapper>
                </SlideComponentWrapper>
                <SettingTextWrapper>
                  <TextWrapper>
                    <MessageText>{renderText(data.text)}</MessageText>
                    <CharCountText>{decideMessageInfo(data.text)}</CharCountText>
                  </TextWrapper>
                </SettingTextWrapper>
                <ButtonWrapper>
                  <PlusButtonWrapper onClick={() => onClickAddOrDeleteButton(data, index === 0)}>
                    {index === 0 ? <CopyIcon /> : <ExitButtonIcon />}
                  </PlusButtonWrapper>
                  <ModifyButton onClick={() => onClickEdit(data)}>
                    <EditIcon />
                  </ModifyButton>
                </ButtonWrapper>
              </SettingColumnBox>
            </SettingColumnBoxWrapper>
          )
        }
        <DivisionLine />
        <SettingColumnBox>
          <SlideComponentWrapper onClick={() => onClickToggle('ApplyMembershipHolding', -1)}>
            <SlideOutBox isClicked={expired.applyMembershipHolding.isUseSetting}>
              <SlideInBox isClicked={expired.applyMembershipHolding.isUseSetting} />
            </SlideOutBox>
            <SettingOptionTextWrapper>
              <Text style={{ whiteSpace: "nowrap" }} fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.text} hover='pointer'>{t('messageSend.editModal.descApplyMembershipHolding')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} hover='pointer'>{t('messageSend.editModal.descImmediatelyOnHolding')}</Text>
            </SettingOptionTextWrapper>
          </SlideComponentWrapper>
          <SettingTextWrapper>
            <TextWrapper>
              <MessageText>{renderText(expired.applyMembershipHolding.text)}</MessageText>
              <CharCountText>{decideMessageInfo(expired.applyMembershipHolding.text)}</CharCountText>
            </TextWrapper>
          </SettingTextWrapper>
          <ButtonWrapper>
            <ModifyButton onClick={() => onClickEdit(expired.applyMembershipHolding)}>
              <EditIcon />
            </ModifyButton>
          </ButtonWrapper>
        </SettingColumnBox>

        <DivisionLine />

        <SettingColumnBox>
          <SlideComponentWrapper>
            <SlideOutBox
              isClicked={expired.startMembershipHolding.isUseSetting}
              onClick={() => onClickToggle('StartMembershipHolding', -1)}>
              <SlideInBox isClicked={expired.startMembershipHolding.isUseSetting} />
            </SlideOutBox>
            <CheckBoxTextWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.text}>{t('messageSend.autoMessage.holdingActivation')}</Text>
              <SettingCaptionTextWrapper>
                <InputWrapper onClick={e => e.stopPropagation()}>
                  <SettingInput
                    value={expired.startMembershipHolding.applyDay}
                    setValue={onChangeStartMembershipHoldingDay}
                    placeholder={0} />
                </InputWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('messageSend.autoMessage.daysBefore')}</Text>
                <InputWrapper onClick={e => e.stopPropagation()}>
                  <SettingInput
                    value={expired.startMembershipHolding.applyTime}
                    setValue={onChangeStartMembershipHoldingTime}
                    placeholder='00:00'
                    isTimeType={true} />
                </InputWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('messageSend.autoMessage.atTime')}</Text>
              </SettingCaptionTextWrapper>
            </CheckBoxTextWrapper>
          </SlideComponentWrapper>
          <SettingTextWrapper>
            <TextWrapper>
              <MessageText>{renderText(expired.startMembershipHolding.text)}</MessageText>
              <CharCountText>{decideMessageInfo(expired.startMembershipHolding.text)}</CharCountText>
            </TextWrapper>
          </SettingTextWrapper>
          <ButtonWrapper>
            <ModifyButton onClick={() => onClickEdit(expired.startMembershipHolding)}>
              <EditIcon />
            </ModifyButton>
          </ButtonWrapper>
        </SettingColumnBox>

      </SettingBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const DivisionBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  height: 53px;

  gap: 6px;
`;

const DuplicateLimitWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  gap: 20px;
`;

const DuplicateLimitTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 5px;
`;

const DuplicateLimitControlWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 9px 0px;

  gap: 10px;
`;

const StateTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 60px;
`;

const SettingBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 10px 20px;

  box-sizing: border-box;
  width: 100%;

  gap: 10px;

  border-radius: 10px;

  background-color: ${props => props.theme.subBackground};
`;

const SettingColumnBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const SettingColumnBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  min-height: 40px;
`;

const SlideComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding-right: 20px;

  box-sizing: border-box;
  width: 370px;
  height: 100%;

  gap: 30px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SlideOutBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  flex-shrink: 0;
  box-sizing: border-box;
  width: 70px;
  height: 32px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 9px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const SlideInBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-left: ${props => props.isClicked ? '43px' : '4px'};

  width: 22px;
  height: 22px;

  border-radius: 7px;
  background-color: ${props => props.isClicked ? props.theme.white : props.theme.line};

  transition: all 0.3s ease-in-out;
`;

const SettingOptionTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;

  gap: 3px;
`;

const CheckBoxTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  gap: 5px;
`;

const SettingCaptionTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 5px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 50px;
  height: 30px;
`;

const PlusButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const CopyIcon = styled(CopySvg)`
  width: 18px;
  height: 18px;
  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.line};
  }

  transition: all 0.3s ease-in-out;
`;

const ExitButtonIcon = styled(ExitButtonSvg)`
  width: 11px;
  height: 11px;
  flex-shrink: 0;

  & path, & rect {
    fill: ${props => props.theme.line};
  }

  transition: all 0.3s ease-in-out;
`;

const SettingTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 566px;
  height: 100%;

  border-left: 1px solid ${props => props.theme.line};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 10px 15px;

  gap: 5px;

  box-sizing: border-box;
  width: 100%;
`;

const MessageText = styled.div`
  display: block;
`;

const MessageLine = styled.div`
  display: block;

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  line-height: 21px;
  color: ${props => props.theme.text};

  &:not(:last-child) {
    margin-bottom: 5px;
  }
`;

const CharCountText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0;
`;

const UnsubscribeText = styled.p`
  margin: 8px 0 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  line-height: 21px;

  color: ${props => props.theme.line};
`;

const VariableChip = styled.span`
  display: inline-flex;
  align-items: center;

  padding: 0 5px;

  height: 21px;

  border-radius: 5px;
  background-color: ${props => props.theme.primaryAlpha20};

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  color: ${props => props.theme.text};

  transition: all 0.3s ease-in-out;
`;

const EditIcon = styled(EditSvg)`
  width: 18px;
  height: 18px;
  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.line};
  }

  transition: all 0.3s ease-in-out;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 59px;
  height: 100%;

  gap: 25px;

  background-color: ${props => props.theme.subBackground};
`;

const ModifyButton = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const DivisionLine = styled.div`
  width: calc(100% - 20px);
  height: 1px;

  margin: 10px 0px;

  background-color: ${props => props.theme.line};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;
